// @spec SUP-STR-037
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { SupplierReviewPage } from '@/features/suppliers/review/components/SupplierReviewPage';
import { useOrganizations } from '@/hooks/use-organizations';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/suppliers/$supplierId/reviews/$reviewId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.supplierReview'),
  }),
  component: ReviewRoute,
});

/**
 * Route component for the supplier review page.
 * Gets org context and renders the review page component.
 */
function ReviewRoute() {
  // Route.useParams() returns supplierId and reviewId as inferred from the route path
  // Type safety provided by TanStack Router's generated route tree
  const { supplierId, reviewId } = Route.useParams();
  const { organizations } = useOrganizations();

  const activeOrg = organizations.find((org) => org.isActive);

  if (!activeOrg) {
    return (
      <div className="min-h-screen bg-background p-8">
        <div className="mx-auto max-w-4xl text-center">
          <p className="text-muted-foreground">Please select an organization to view the review.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-4xl">
        <SupplierReviewPage orgId={activeOrg.id} supplierId={supplierId} reviewId={reviewId} />
      </div>
    </div>
  );
}
